import TAppVersionEdit from './index.vue';

TAppVersionEdit.install = app => {
  app.component(TAppVersionEdit.name, TAppVersionEdit);
};

export default TAppVersionEdit;
